<nz-page-header (nzBack)="back()" nzBackIcon>
    <nz-breadcrumb nz-page-header-breadcrumb>
        <pbc-breadcrumbs [pages]="page.breadcrumbs"></pbc-breadcrumbs>
    </nz-breadcrumb>
    <nz-page-header-title>
        🕒 Meine Arbeitszeiten
    </nz-page-header-title>
    <nz-page-header-extra>
        <nz-space>
            <nz-button-group>
                <button nz-button 
                    [nzType]="view == 'kacheln' ? 'primary' : 'default'"
                    (click)="onSwitchView('kacheln')">
                    Kacheln
                </button>
                <button nz-button 
                    [nzType]="view == 'kalender' ? 'primary' : 'default'"
                    (click)="onSwitchView('kalender')">
                    Kalender
                </button>
            </nz-button-group>
            <ng-container *ngIf="(auth.$isOM | async) || (auth.$isPartner | async)">
                <nz-divider nzType="vertical"></nz-divider>
                <nz-select nzMode="default" nzPlaceHolder="Mitarbeiter auswählen" nzAllowClear nzShowSearch
                    nzPlacement="bottomRight" [(ngModel)]="selectedMitarbeiter" (ngModelChange)="onSelectMitarbeiter()">
                    <ng-container *ngFor="let mitarbeiter of mitarbeiter">
                        <nz-option *ngIf="!isLoadingMitarbeiter" [nzValue]="mitarbeiter.id"
                            [nzLabel]="mitarbeiter.anzeigename"></nz-option>
                    </ng-container>
                    <nz-option *ngIf="isLoadingMitarbeiter" nzDisabled nzCustomContent>
                        <span nz-icon nzType="loading" class="loading-icon"></span>
                        Lade Mitarbeiter...
                    </nz-option>
                </nz-select>
            </ng-container>
        </nz-space>
    </nz-page-header-extra>
</nz-page-header>

<ng-template #CardTitleAktivitaeten>
    <span nz-icon nzType="ordered-list" nzTheme="outline" style="margin-right: 8px"></span>
    <span>Aktivitäten</span>
</ng-template>

<ng-template #CardActionsAktivitaeten>
    <nz-button-group *ngIf="!isVisibleSelectCustomZeitraum">
        <button nz-button 
            [nzType]="aktuellerZeitraum == 'aktueller-monat' ? 'primary' : 'default'"
            (click)="onClickZeigeAktuellerMonat()">
            Aktueller Monat
        </button>
        <button nz-button 
            [nzType]="aktuellerZeitraum == 'letzter-monat' ? 'primary' : 'default'"
            (click)="onClickZeigeLetzerMonat()">
            Letzter Monat
        </button>
        <button nz-button 
            [nzType]="aktuellerZeitraum == 'dieses-jahr' ? 'primary' : 'default'"
            (click)="onClickZeigeDiesesJahr()">
            Dieses Jahr
        </button>
        <button nz-button 
            [nzType]="aktuellerZeitraum == 'custom-zeitraum' ? 'primary' : 'default'"
            (click)="onClickCustomZeitraum()">
            Zeitraum auswählen
        </button>
    </nz-button-group>
    <nz-range-picker *ngIf="isVisibleSelectCustomZeitraum"
        [(ngModel)]="customZeitraum"
        (ngModelChange)="onChangeCustomZeitraum($event)">
    </nz-range-picker>
</ng-template>

<ng-template #CardTitleArbeitszeitkonto>
    <span style="margin-right: 8px">⏳️</span>
    <span>Arbeitszeitkonto</span>
</ng-template>

<ng-template #CardTitleUrlaubskonto>
    <span nz-icon style="margin-right: 8px;">🏖️</span>
    <span>Urlaubskonto {{ jahr }}</span>
</ng-template>

<ng-template #CardTitleKrankheiten>
    <span nz-icon style="margin-right: 8px;">🤒</span>
    <span>Krankheitstage {{ jahr }}</span>
</ng-template>

<ng-template #DayList let-days="days">
    <nz-list nzSize="small">
        <nz-list-item *ngFor="let day of days">
            {{day| date:'EEEE'}}, {{day | date:'dd.MM.YYYY'}}
        </nz-list-item>
    </nz-list>
</ng-template>

<ng-template #TooltipArbeitszeitKontoAktuellesJahr>
    <nz-list nzSize="small">
        <nz-list-item>
            Überstunden aus {{($arbeitszeitKontoAktuellesJahr | async).saldoUebertragVorJahr.jahr}}: {{ ($arbeitszeitKontoAktuellesJahr | async).saldoUebertragVorJahr.uebertragMinutenAusVorJahr | minutesToHours }}
        </nz-list-item>
        <nz-list-item>
            Überstunden dieses Jahr: {{ ($arbeitszeitKontoAktuellesJahr | async).saldoInMinuten | minutesToHours }}
        </nz-list-item>
    </nz-list>
</ng-template>

<div *ngIf="view === 'kalender'">
    <nz-spin [nzSpinning]="loading$ | async">
        <nz-calendar 
            [(ngModel)]="calenderDate"
            [nzMode]="'month'"
            [nzDisabledDate]="calenderDisabledDate"
            (nzPanelChange)="calenderPanelChange($event)"
            (nzSelectChange)="calenderSelectChange($event)">
            <ng-template #dateCell let-date nzDateCell>
                <ul class="events">
                    <li *ngFor="let event of calenderGetEvents(date)">
                        <div [ngSwitch]="event.type">
                            <div *ngSwitchCase="'arbeitstag'">
                                <span nz-icon style="margin-right: 8px;">🕘</span>
                                <span nz-typography nzType="success">Arbeitstag ({{ event.anzahlMinuten | minutesToHours }})</span>
                            </div>
                            <div *ngSwitchCase="'urlaub'" nzColor="warning">
                                <span nz-icon style="margin-right: 8px;">🏖️</span>
                                <span nz-typography nzType="warning">Urlaub</span>
                            </div>
                            <div *ngSwitchCase="'feiertag'" nzColor="error">
                                <span nz-icon style="margin-right: 8px;">🎉</span>
                                <span nz-typography nzType="danger">Feiertag ({{ event.name | nbSpace }})</span>
                            </div>
                            <div *ngSwitchCase="'krankheit'" nzColor="secondary">
                                <span nz-icon style="margin-right: 8px;">🤒</span>
                                <span>Krankheit</span>
                            </div>
                        </div>
                    </li>
                </ul>
            </ng-template>
        </nz-calendar>
    </nz-spin>
</div>

<div *ngIf="view === 'kacheln'">
    <div nz-row [nzGutter]="[16, 16]">
        <div nz-col nzFlex="3">
            <nz-spin [nzSpinning]="loading$ | async">
                <nz-card [nzTitle]="CardTitleAktivitaeten" [nzExtra]="CardActionsAktivitaeten">
                    <!-- <ng-container *ngFor="let monat of monateMitZeiten">
                        <nz-divider [nzText]="getMonthName(monat)"></nz-divider>
                    </ng-container>-->
                    <ng-container *ngIf="tageNichtZugeordnet && tageNichtZugeordnet.length > 0">
                        <ng-template #alertNichtZugeordneteTageTpl>
                            <nz-list nzBordered nzSize="small">
                                <nz-list-item *ngFor="let tag of tageNichtZugeordnet">
                                    {{formatNichtZugeordneterTagDetails(tag)}}
                                </nz-list-item>
                            </nz-list>
                        </ng-template>
                        <nz-alert
                            nzType="warning"
                            nzMessage="Nicht zugeordnete Tage gefunden"
                            [nzDescription]="alertNichtZugeordneteTageTpl"
                            nzShowIcon>
                        </nz-alert>
                        <br />
                    </ng-container>
                    <nz-empty 
                        *ngIf="tageSortiert && tageSortiert.length == 0" 
                        nzNotFoundContent="Keine Aktivitäten für den Zeitraum gefunden" />
                    <nz-collapse *ngIf="tageSortiert && tageSortiert.length > 0">
                        <nz-collapse-panel 
                            *ngFor="let day of tageSortiert"
                            nzHeader="{{formatDayDetails(day)}}"
                            (nzActiveChange)="onPanelDayActivitiesChange(day, $event)">
                            <nz-table #table [nzData]="zeiten[day]?.records" [nzShowPagination]="false">
                                <thead>
                                    <tr>
                                        <th>Start</th>
                                        <th>Ende</th>
                                        <th>Zeitart</th>
                                        <th>Zeitunterart</th>
                                        <th>Projekt Bezeichnung (Kunde / Projektnummer)</th>
                                        <th>Dauer</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of table.data">
                                        <td>{{formatDateAsTime(row.start)}}</td>
                                        <td>{{formatDateAsTime(row.ende)}}</td>
                                        <td>{{zeitArten[row.zeitArt]?.name}}</td>
                                        <td>{{zeitUnterarten[row.zeitUnterart]?.name}}</td>
                                        <td>{{getProjektLabel(row.projekt)}}</td>
                                        <td>{{row.stunden}}h {{row.minuten}}m</td>
                                        <!--<button nz-button nzType="primary">bearbeiten</button>
                                        <button nz-button nzType="primary">löschen</button>-->
                                    </tr>
                                </tbody>
                            </nz-table>
                        </nz-collapse-panel>
                    </nz-collapse>
                </nz-card>
            </nz-spin>
        </div>
        <div nz-col nzFlex="2">
            <nz-card [nzTitle]="CardTitleArbeitszeitkonto">
                <nz-spin [nzSpinning]="loading$ | async">
                    <nz-table [nzTemplateMode]="true" [nzShowPagination]="false">
                        <tbody>
                            <tr>
                                <td colspan="3" style="font-weight: bold; background: #fafafa;">
                                    Arbeitszeitkonto
                                </td>
                            </tr>
                            <tr>
                                <td>Über-/Fehlstunden</td>
                                <td>
                                    <span 
                                        [style.color]="getColorArbeitszeitKontoArbeitszeit(($arbeitszeitKontoAktuellesJahr | async)?.saldoInMinuten)"
                                        nz-tooltip [nzTooltipTitle]="TooltipArbeitszeitKontoAktuellesJahr"
                                        nzTooltipColor="cyan">
                                        {{($arbeitszeitKontoAktuellesJahr | async)?.saldoInMinuten | minutesToHours}}
                                    </span>
                                </td>
                            </tr>
                             <tr>
                                <td colspan="3" style="font-weight: bold; background: #fafafa;">
                                    Zeitraum: {{ ($arbeitszeitKonto | async)?.from | date:'dd.MM.yyyy' }} - {{ ($arbeitszeitKonto | async)?.to | date:'dd.MM.yyyy' }}
                                </td>
                            </tr>
                            <tr>
                                <td>zu leistende Stunden</td>
                                <td>{{($arbeitszeitKonto | async)?.sollArbeitszeitInStunden}}h</td>
                            </tr>
                            <tr>
                                <td>geleistete Stunden</td>
                                <td>{{($arbeitszeitKonto | async)?.geleisteteArbeitszeitInMinuten | minutesToHours}}</td>
                            </tr>
                            <tr>
                                <td>Über-/Fehlstunden</td>
                                <td>
                                    <span [style.color]="getColorArbeitszeitKontoArbeitszeit(($arbeitszeitKonto | async)?.saldoInMinuten)">
                                        {{($arbeitszeitKonto | async)?.saldoInMinuten | minutesToHours}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </nz-table>
                </nz-spin>
            </nz-card>
            <br />
            <nz-card [nzTitle]="CardTitleUrlaubskonto">
                <nz-spin [nzSpinning]="loading$ | async">
                    <nz-table [nzTemplateMode]="true" [nzShowPagination]="false">
                        <tbody>
                            <tr>
                                <td>Urlaubstage {{ jahr }}</td>
                                <td>
                                    <span>{{($urlaubsKonto | async)?.jahr.anspruchUrlaub}}&nbsp;Tage</span>
                                </td>
                            </tr>
                            <tr *ngIf="($urlaubsKonto | async)?.jahr.anspruchSonderurlaub > 0">
                                <td>
                                    Sonderurlaub {{ jahr }}
                                </td>
                                <td>
                                    <span>{{($urlaubsKonto | async)?.jahr.anspruchSonderurlaub}}&nbsp;Tage</span>
                                </td>
                            </tr>
                            <tr *ngIf="($urlaubsKonto | async)?.['übertrag'].erlaubt > 0">
                                <td>Resturlaub {{($urlaubsKonto | async)?.['übertrag'].aus}} (bis&nbsp;{{($urlaubsKonto | async)?.['übertrag'].bis | date:'dd.MM.YYYY'}})</td>
                                <td>{{ getUrlaubsKontoInfo(($urlaubsKonto | async)) }}</td>
                            </tr>
                            <tr>
                                <td>Anzahl Urlaubstage {{ jahr }}</td>
                                <td>
                                    <span>{{($urlaubsKonto | async)?.jahr.erlaubt}}&nbsp;Tage</span>
                                </td>
                            </tr>
                            <tr>
                                <td>genehmigte Tage</td>
                                <td>{{($urlaubsKonto | async)?.jahr.genommen}}&nbsp;Tage</td>
                            </tr>
                            <tr>
                                <td>verbleibende Urlaubstage</td>
                                <td>{{($urlaubsKonto | async)?.jahr['verfügbar']}}&nbsp;Tage</td>
                            </tr>
                        </tbody>
                    </nz-table>
                    <nz-table nzTitle="Urlaubszeiten" #urlaubTable [nzData]="$urlaube|async" [nzShowPagination]="false">
                        <tbody>
                            <tr *ngFor="let row of urlaubTable.data">
                                <td>
                                    {{formatDateRange(row.von, row.bis)}}
                                </td>
                                <td>
                                    <span nz-tooltip [nzTooltipTitle]="DayList" [nzTooltipTitleContext]="{days: row.tage}" nzTooltipColor="cyan">
                                        Urlaub ({{row.anzahlTage}}&nbsp;Arbeitstage)
                                    </span>
                                </td>
                                <td>
                                    <ng-container *ngIf="row.angenommen; else checkAbgelehnt">
                                        <nz-tag nzColor="success">
                                            <span nz-icon nzType="check-circle"></span>
                                            <span>Angenommen</span>
                                        </nz-tag>
                                    </ng-container>
                                    <ng-template #checkAbgelehnt>
                                        <ng-container *ngIf="row.abgelehnt; else defaultCase">
                                            <nz-tag nzColor="error">
                                                <span nz-icon nzType="close-circle"></span>
                                                <span>Abgelehnt</span>
                                            </nz-tag>
                                        </ng-container>
                                    </ng-template>
                                    <ng-template #defaultCase>
                                        <nz-tag nzColor="default">
                                            <span nz-icon nzType="clock-circle"></span>
                                            <span>Offen</span>
                                        </nz-tag>
                                    </ng-template>
                                </td>
                            </tr>
                        </tbody>
                    </nz-table>
                </nz-spin>
            </nz-card>
            <br />
            <nz-card [nzTitle]="CardTitleKrankheiten">
                <nz-spin [nzSpinning]="loading$ | async">
                    <nz-table #krankheitstageTable [nzData]="$krankheitstage|async" [nzShowPagination]="false">
                        <tbody>
                            <tr *ngFor="let row of krankheitstageTable.data">
                                <td>
                                    {{row.von | date:'dd.MM.yyyy' }} - {{row.bis | date:'dd.MM.yyyy' }}
                                </td>
                                <td>
                                    <span nz-tooltip [nzTooltipTitle]="DayList" [nzTooltipTitleContext]="{days: row.tage}"
                                        nzTooltipColor="cyan">
                                        {{row.tage.length}}&nbsp;Arbeitstage
                                    </span>
                                </td>
                                <td>
                                    <ng-container *ngIf="row.bescheinigt; else checkNichtBescheinigt">
                                        <nz-tag nzColor="success">
                                            <span nz-icon nzType="check-circle"></span>
                                            <span>bescheinigt</span>
                                        </nz-tag>
                                    </ng-container>
                                    <ng-template #checkNichtBescheinigt>
                                        <nz-tag nzColor="error">
                                            <span nz-icon nzType="close-circle"></span>
                                            <span>nicht bescheinigt</span>
                                        </nz-tag>
                                    </ng-template>
                                </td>
                            </tr>
                        </tbody>
                    </nz-table>
                </nz-spin>
            </nz-card>
        </div>
    </div>
</div>